// El catálogo ya está limitado por los permisos del usuario en el controlador.
function initPoaImportDependencies() {
    const form = document.getElementById('poa-import-form');
    if (!form || form.dataset.dependenciesBound === 'true') return;
    form.dataset.dependenciesBound = 'true';
    const dependencies = JSON.parse(form.dataset.dependencies);
    const faculty = form.querySelector('#import_faculty_id');
    const filial = form.querySelector('#import_filial_id');
    const dependency = form.querySelector('#dependency_id');

    function populate(select, entries, prompt, enabled) {
        select.replaceChildren(new Option(prompt, ''));
        entries.forEach(entry => select.add(new Option(entry.name, entry.id)));
        select.disabled = !enabled;
    }

    faculty.addEventListener('change', function () {
        const filials = new Map();
        dependencies.filter(item => String(item.faculty_id) === faculty.value).forEach(item => {
            filials.set(item.filial_id, { id: item.filial_id, name: item.filial_name });
        });
        populate(filial, Array.from(filials.values()).sort((a, b) => a.name.localeCompare(b.name)),
            'Selecciona una filial', !!faculty.value);
        populate(dependency, [], 'Detectar desde el archivo', false);
    });

    filial.addEventListener('change', function () {
        const filtered = dependencies.filter(item =>
            String(item.faculty_id) === faculty.value && String(item.filial_id) === filial.value);
        populate(dependency, filtered, 'Detectar desde el archivo', !!faculty.value && !!filial.value);
    });
}

document.addEventListener('turbolinks:load', initPoaImportDependencies);
document.addEventListener('DOMContentLoaded', initPoaImportDependencies);
